import { createSelector } from 'reselect';

const dataSelector = state => state.data;
const dataIndexSelector = state => state.dataIndex;
const dataRegioSelector = state => state.dataRegio;
const regioIdSelector = state => state.regioId;
const brexitSelector = state => state.brexit;

export const currentDataSelector = createSelector(
  [dataSelector, dataIndexSelector, brexitSelector],
  (data, index, brexit) => {
    if (!data) {
      return false;
    }

    const result = Object.assign({}, data[index]);

    if (brexit && index === data.length - 1) {
      result.seatsTotal = result.seatsTotal - result.seatsTotalUK;
      result.groups = result.groups
        .map(g => {
          return Object.assign({}, g, { seatsTotal: g.seatsTotal - g.seatsTotalUK });
        })
        .sort((a, b) => b.seatsTotal - a.seatsTotal);
    }

    return result;
  }
);

export const startYearSelector = createSelector(
  [currentDataSelector, dataIndexSelector, dataSelector],
  (currentData, dataIndex, data) => {
    if (!currentData) {
      return '';
    }

    return currentData.startYear;
  }
);

export const regioDataSelector = createSelector(
  [currentDataSelector, dataRegioSelector, regioIdSelector],
  (currentData, dataRegio, regioId) => {
    if (!currentData || !dataRegio) {
      return false;
    }

    return dataRegio[regioId][currentData.startYear];
  }
);
